import(/* webpackMode: "eager" */ "/var/www/pechatnov/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/homepage/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/ocenka-nedvizhimosti/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/ocenka-nedvizhimosti/components/PricingCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/ocenka-nedvizhimosti/components/ProcessTimeline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/app/ocenka-nedvizhimosti/components/PropertyHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pechatnov/src/components/ui/AppImage.tsx");
